import React from 'react';

function Pages() {
  return (
    <section className="pages section-padding" data-scroll-index="2">
      <div className="container">
        <div className="row mb-30">
          <div className="col-lg-7 col-md-10">
            <h6 className="sub-title main-color mb-15">Awesome Inner Pages</h6>
            <h2>
              A collection of readymade inner page templates and flexible
              elements
            </h2>
          </div>
        </div>
        <div className="marq-pages">
          <div className="main-marq">
            <div className="slide-har st1">
              <div className="box">
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/1.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/19.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/2.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/18.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/3.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/17.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/4.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/16.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/5.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/15.png" alt="" />
                  </div>
                </div>
              </div>
              <div className="box">
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/1.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/19.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/2.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/18.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/3.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/17.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/4.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/16.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/5.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/15.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="marq-pages">
          <div className="main-marq mt-30">
            <div className="slide-har st2">
              <div className="box">
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/6.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/14.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/7.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/13.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/8.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/12.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/9.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/11.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/10.png" alt="" />
                  </div>
                </div>
              </div>
              <div className="box">
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/6.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/14.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/7.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/13.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/8.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/12.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/9.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/11.png" alt="" />
                  </div>
                </div>
                <div className="item">
                  <div className="img">
                    <img src="/landing-preview/img/pages/10.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-end mt-30">
          <div className="col-lg-8">
            <div className="states d-flex align-items-center justify-content-end">
              <div>
                <h2>40+</h2>
                <h6 className="sub-title p-color mt-10">Elements</h6>
              </div>
              <div className="bord-thin-left item">
                <h2>8+</h2>
                <h6 className="sub-title p-color mt-10">Inner Pages</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pages;
